import React, { Component } from 'react'
import { isNull } from 'lodash'
import { Redirect } from 'react-router-dom'

class LoginKC extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: props.user,
      redirect: props.redirect,
      login: props.login
    }
  }

  componentWillReceiveProps(nextProps) {
    this.state = {
      user: nextProps.user,
      redirect: nextProps.redirect,
      login: nextProps.login
    }
  }

  componentDidMount() {
    this.state.login()
  }

  render() {
    if (this.state.user) {
      return !isNull(this.state.redirect) ? (
        <Redirect to={this.state.redirect} />
      ) : null
    } else {
      return <div>Initializing Keycloak...</div>
    }
  }
}

export default LoginKC
